import React from "react";

const TitleBar = () => {
  return (
    <header className="flex h-9 shrink-0 items-center justify-center bg-vscode-titlebar px-3 text-vscode-text select-none">
      <div className="flex items-center gap-2">
        <img src="/icon.svg" alt="" className="h-4 w-4" />
        <span className="text-xs font-medium tracking-wide">CodeBase</span>
      </div>
    </header>
  );
};

export default TitleBar;
